/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

const PT = {
  'action.accept': 'Aceitar',
  'action.cancel': 'Cancelar',
  'action.delete': 'Excluir',
  'action.duplicate': 'Duplicar',
  'action.export': 'Exportar',
  'action.import': 'Importar',
  'action.new': 'Novo',
  'action.open': 'Abrir',
  'action.print': 'Imprimir',
  'action.publish': 'Publicar',
  'action.rename': 'Renomear',
  'action.share': 'Compartilhar',
  'appbar.back-to-map-list': 'Voltar à lista de mapas',
  'appbar.button-signup': 'Cadastrar',
  'appbar.shared-button': 'Compartilhar',
  'appbar.tooltip-export': 'Exportar',
  'appbar.tooltip-history': 'Histórico de alterações',
  'appbar.tooltip-info': 'Informações',
  'appbar.tooltip-print': 'Imprimir',
  'appbar.tooltip-publish': 'Publicar',
  'appbar.tooltip-redo': 'Refazer',
  'appbar.tooltip-save': 'Salvar',
  'appbar.tooltip-shared': 'Compartilhar para colaboração',
  'appbar.tooltip-signup': 'Cadastrar',
  'appbar.tooltip-starred': 'Favoritos',
  'appbar.tooltip-undo': 'Desfazer',
  'editor-panel.icon-title': 'Ícone',
  'editor-panel.link-panel-title': 'Link',
  'editor-panel.note-panel-title': 'Nota',
  'editor-panel.tooltip-add-icon': 'Adicionar ícone',
  'editor-panel.tooltip-add-link': 'Adicionar link',
  'editor-panel.tooltip-add-note': 'Adicionar nota',
  'editor-panel.tooltip-add-relationship': 'Adicionar relacionamento',
  'editor-panel.tooltip-add-topic': 'Adicionar tópico',
  'editor-panel.tooltip-connection-color': 'Cor',
  'editor-panel.tooltip-connection-color-default': 'Cor padrão',
  'editor-panel.tooltip-connection-style': 'Estilo de conexão',
  'editor-panel.tooltip-connection-style-curved-thick': 'Curva grossa',
  'editor-panel.tooltip-connection-style-curved-thin': 'Curva fina',
  'editor-panel.tooltip-connection-style-polyline': 'Polilinha simples',
  'editor-panel.tooltip-connection-style-polyline-curved': 'Polilinha curva',
  'editor-panel.tooltip-delete-topic': 'Excluir tópico',
  'editor-panel.tooltip-topic-border-color': 'Cor da borda',
  'editor-panel.tooltip-topic-border-color-default': 'Cor da borda padrão',
  'editor-panel.tooltip-topic-fill-color': 'Cor de preenchimento',
  'editor-panel.tooltip-topic-fill-color-default': 'Cor de preenchimento padrão',
  'editor-panel.tooltip-topic-font-bigger': 'Maior',
  'editor-panel.tooltip-topic-font-bold': 'Negrito',
  'editor-panel.tooltip-topic-font-color': 'Cor',
  'editor-panel.tooltip-topic-font-color-default': 'Cor padrão',
  'editor-panel.tooltip-topic-font-italic': 'Itálico',
  'editor-panel.tooltip-topic-font-smaller': 'Menor',
  'editor-panel.tooltip-topic-font-style': 'Estilo da fonte',
  'editor-panel.tooltip-topic-share-ellipse': 'Forma elíptica',
  'editor-panel.tooltip-topic-share-line': 'Forma de linha',
  'editor-panel.tooltip-topic-share-rectangle': 'Forma retangular',
  'editor-panel.tooltip-topic-share-rounded': 'Forma arredondada',
  'editor-panel.tooltip-topic-style': 'Estilo do tópico',
  'editor.edit-description-mobile': 'Funcionalidades limitadas de edição de mapa mental são suportadas em dispositivos móveis. Use um navegador desktop para funcionalidades completas do editor.',
  'editor.try-welcome': 'Este espaço de edição mostra algumas das capacidades do editor de mapas mentais!',
  'editor.try-welcome-description': 'Cadastre-se para começar a criar, compartilhar e publicar um número ilimitado de mapas mentais gratuitamente.',
  'editor.try-welcome-description-mobile': 'Cadastre-se para começar a criar, compartilhar e publicar um número ilimitado de mapas mentais gratuitamente. ' +
    'Funcionalidades limitadas de edição de mapa mental são suportadas em dispositivos móveis. Use um navegador desktop para funcionalidades completas do editor.',
  'editor.try-welcome-mobile': 'Este espaço de edição mostra algumas das capacidades do editor de mapas mentais!',
  'icon-picker.show-images': 'Mostrar imagens',
  'link.help_text': 'Endereço inválido',
  'link.placeholder': 'https://www.example.com',
  'shortcut-help-pane.action': 'Ação',
  'shortcut-help-pane.add-child': 'Adicionar tópico filho',
  'shortcut-help-pane.add-link': 'Adicionar link',
  'shortcut-help-pane.add-note': 'Adicionar nota',
  'shortcut-help-pane.add-sibling': 'Adicionar tópico irmão',
  'shortcut-help-pane.cancel-text-changes': 'Cancelar alterações de texto',
  'shortcut-help-pane.change-font-bold': 'Alterar texto para negrito',
  'shortcut-help-pane.change-font-italic': 'Alterar texto para itálico',
  'shortcut-help-pane.collapse-children': 'Recolher filhos',
  'shortcut-help-pane.copy-and-text': 'Copiar e colar tópicos/Copiar imagem do mapa mental para a área de transferência.',
  'shortcut-help-pane.delete-topic': 'Excluir tópico',
  'shortcut-help-pane.deselect-all-topics': 'Desmarcar todos os tópicos',
  'shortcut-help-pane.drag-disconnect': 'Desconectar tópico',
  'shortcut-help-pane.edit-multiline': 'Adicionar texto de tópico multilinha',
  'shortcut-help-pane.edit-topic': 'Editar texto do tópico',
  'shortcut-help-pane.edit-topic-key': 'F2 ou duplo clique',
  'shortcut-help-pane.navigation': 'Navegação',
  'shortcut-help-pane.navigation-keys': 'Teclas de seta',
  'shortcut-help-pane.overwrite-edit-topic': 'Sobrescrever texto do tópico',
  'shortcut-help-pane.overwrite-edit-topic-key': 'Digitar em um tópico selecionado',
  'shortcut-help-pane.redo': 'Refazer edição',
  'shortcut-help-pane.save-changes': 'Salvar alterações',
  'shortcut-help-pane.select-all-topics': 'Selecionar todos os tópicos',
  'shortcut-help-pane.select-topics': 'Selecionar múltiplos tópicos',
  'shortcut-help-pane.select-topics-keys': 'Clique do mouse',
  'shortcut-help-pane.undo': 'Desfazer edição',
  'zoom-panel.tooltip-keyboard': 'Atalhos do teclado',
  'zoom-panel.tooltip-zoom-in': 'Aumentar zoom',
  'zoom-panel.tooltip-zoom-out': 'Diminuir zoom',
  'zoom-panel.tooltip-zoom-to-fit': 'Ajustar ao tamanho',
  'creator-info-pane.description': 'Descrição',
  'creator-info-pane.creator': 'Criador',
  TAB_TO_CREATE_CHILD: 'para criar filho',
  ENTER_TO_CREATE_SIBLING: 'para criar irmão',
  PLUS_TOOLTIP_CREATE_CHILD: 'Criar tópico filho',
  PLUS_TOOLTIP_CREATE_SIBLING: 'Criar tópico irmão',
};

export default PT;
